module.exports = __webpack_public_path__ + "static/media/member_red.0c5acd6b.svg";